"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTotalHoursDuration = exports.getTotalHoursStringATPlus = exports.getTotalHoursString = exports.TotalHours = exports.TOTAL_HOURS_TEST_ID = exports.INVALID_TOTAL_HOURS_STRING = void 0;
const Col_1 = require("@amzn/atoz-web/Col");
const Text_1 = require("@amzn/atoz-web/Text");
const luxon_1 = require("luxon");
const react_1 = __importDefault(require("react"));
const DateManagement_1 = require("../../../../../utils/DateManagement");
exports.INVALID_TOTAL_HOURS_STRING = '--';
exports.TOTAL_HOURS_TEST_ID = 'total-hours';
const TotalHours = ({ totalHoursString }) => {
    return (react_1.default.createElement(Col_1.Col, { gridGap: "S100" },
        react_1.default.createElement(Text_1.Text, { fontSize: "T100" }, "Total Hours"),
        react_1.default.createElement(Text_1.Text, { fontSize: "T100", fontWeight: "bold", dataTestId: exports.TOTAL_HOURS_TEST_ID }, totalHoursString)));
};
exports.TotalHours = TotalHours;
const getTotalHoursString = (payDataList) => {
    const timeSegments = payDataList.map((payData) => {
        return {
            beginDateTimeStr: payData.beginDateTime,
            endDateTimeStr: payData.endDateTime
        };
    });
    const { totalHoursDuration, isTotalHoursValid } = (0, exports.getTotalHoursDuration)(timeSegments);
    const totalHoursDurationObject = totalHoursDuration.normalize().toObject();
    return isTotalHoursValid
        ? `${totalHoursDurationObject.hours} hr ${totalHoursDurationObject.minutes} min`
        : exports.INVALID_TOTAL_HOURS_STRING;
};
exports.getTotalHoursString = getTotalHoursString;
const getTotalHoursStringATPlus = (payCodeList) => {
    const timeSegments = payCodeList.map((payCode) => {
        return {
            beginDateTimeStr: payCode.startDateTime,
            endDateTimeStr: payCode.endDateTime
        };
    });
    const { totalHoursDuration, isTotalHoursValid } = (0, exports.getTotalHoursDuration)(timeSegments);
    const totalHoursDurationObject = totalHoursDuration.normalize().toObject();
    return isTotalHoursValid
        ? `${totalHoursDurationObject.hours} hr ${totalHoursDurationObject.minutes} min`
        : exports.INVALID_TOTAL_HOURS_STRING;
};
exports.getTotalHoursStringATPlus = getTotalHoursStringATPlus;
const getTotalHoursDuration = (timeSegments) => {
    let totalHoursDuration = luxon_1.Duration.fromMillis(0);
    const mergedSegments = [];
    for (const timeSegment of timeSegments) {
        if (mergedSegments.length == 0) {
            mergedSegments.push(timeSegment);
        }
        else {
            const prevEndDT = luxon_1.DateTime.fromFormat(mergedSegments[mergedSegments.length - 1].endDateTimeStr, DateManagement_1.POPUP_DATE_PICKER_TIME_SELECTOR_FORMAT);
            const curStartDT = luxon_1.DateTime.fromFormat(timeSegment.beginDateTimeStr, DateManagement_1.POPUP_DATE_PICKER_TIME_SELECTOR_FORMAT);
            const curEndDt = luxon_1.DateTime.fromFormat(timeSegment.endDateTimeStr, DateManagement_1.POPUP_DATE_PICKER_TIME_SELECTOR_FORMAT);
            if (curStartDT > prevEndDT)
                mergedSegments.push(timeSegment);
            else if (curStartDT <= prevEndDT && curEndDt > prevEndDT)
                mergedSegments[mergedSegments.length - 1].endDateTimeStr =
                    timeSegment.endDateTimeStr;
        }
    }
    for (const timeSegment of mergedSegments) {
        const [timeSegmentDuration, isTimeSegmentValid] = getTimeSegmentInfo(timeSegment);
        if (isTimeSegmentValid) {
            totalHoursDuration = totalHoursDuration.plus(timeSegmentDuration);
        }
        else {
            return {
                totalHoursDuration: luxon_1.Duration.invalid('Invalid Total Hours'),
                isTotalHoursValid: false
            };
        }
    }
    return {
        totalHoursDuration: totalHoursDuration,
        isTotalHoursValid: true
    };
};
exports.getTotalHoursDuration = getTotalHoursDuration;
const getTimeSegmentInfo = ({ beginDateTimeStr, endDateTimeStr }) => {
    const startDateTime = luxon_1.DateTime.fromFormat(beginDateTimeStr, DateManagement_1.POPUP_DATE_PICKER_TIME_SELECTOR_FORMAT);
    const endDateTime = luxon_1.DateTime.fromFormat(endDateTimeStr, DateManagement_1.POPUP_DATE_PICKER_TIME_SELECTOR_FORMAT);
    const timeSegmentDuration = endDateTime.diff(startDateTime, [
        'hours',
        'minutes'
    ]);
    const isTimeSegmentValid = (timeSegmentDuration.hours == 0 && timeSegmentDuration.minutes > 0) ||
        (timeSegmentDuration.hours > 0 && timeSegmentDuration.minutes >= 0);
    return [timeSegmentDuration, isTimeSegmentValid];
};
